import axios from "axios";
import config from "../config";

/**
 * Create tokenized bank profile
 */

export const createBankAccount = async (token, data) => {
  try {
    let response = await axios({
      method: "post",
      url: `${config.SERVER_URL}/bank-accounts`,
      headers: {
        Authorization: "Bearer " + token,
      },
      data: data,
    });
    return [null, response];
  } catch (error) {
    return [error];
  }
};

export const getBankAccounts = async (token) => {
  try {
    let response = await axios({
      method: "get",
      url: `${config.SERVER_URL}/bank-accounts`,
      headers: {
        Authorization: "Bearer " + token,
      }
    });
    return [null, response];
  } catch (error) {
    return [error];
  }
};

export const addBalance = async (token, data) => {
  try {
    let response = await axios({
      method: "post",
      url: `${config.SERVER_URL}/balances/add`,
      headers: {
        Authorization: "Bearer " + token,
      },
      data: data,
    });
    return [null, response];
  } catch (error) {
    return [error];
  }
};